import React from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useDispatch } from "react-redux";
import PopupMask from "@/componentsUI/PopupMask";
import type { AppDispatch } from "@/features/redux/store";
import { cancelQueuedP20Tasks } from "@/features/modalOrchestrator/modalOrchestratorSlice";
import FirstUpPopup from "./FirstUpPopup";

/**
 * NiceModal 包装层，使 FirstUpPopup 可以通过编排器独立调度。
 * FirstUpPopup 自带全屏遮罩，无需额外 PopupMask。
 */
const FirstUpPopupModal = NiceModal.create(() => {
  const { visible, resolve, remove } = useModal();
  const dispatch = useDispatch<AppDispatch>();

  const handleClose = () => {
    resolve();
    remove();
  };

  // onActionClick 也关闭弹窗（用户点击了 PAY / MORE OFFERS 等行为按钮）
  const handleActionClick = () => {
    dispatch(cancelQueuedP20Tasks());
    resolve();
    remove();
  };

  return (
    <PopupMask visible={visible}>
      <FirstUpPopup onClose={handleClose} onActionClick={handleActionClick} />
    </PopupMask>
  );
});

export default FirstUpPopupModal;
